import api from "services/api";

export async function uploadPersonnelDocument({
  personnelId,
  documentType,
  description,
  file,
}) {
  const formData = new FormData();
  if (personnelId !== undefined && personnelId !== null && personnelId !== "") {
    formData.append("PersonnelId", String(personnelId));
  }
  if (file) {
    formData.append("File", file);
    if (file.name) formData.append("DocumentName", file.name);
  }
  if (documentType) formData.append("DocumentType", documentType);
  if (description) formData.append("Description", description);
  // Debug log để kiểm tra dữ liệu gửi đi
  
  return api.post("/personnel/documents/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function fetchPersonnelDocuments(personnelId) {
  try {
    const response = await api.get(
      `/personnel/documents/by-personnel/${personnelId}`
    );
    return response;
  } catch (error) {
    console.error("Error fetching personnel documents:", error);
    throw error;
  }
}

export async function deletePersonnelDocument(documentId) {
  return api.delete(`/personnel/documents/${documentId}`);
}

export async function downloadPersonnelDocument(documentId) {
  // Sử dụng axios với responseType là blob để tải về file
 
  try {
    const response = await api.get(
      `/personnel/documents/download/${documentId}`,
      {
        responseType: "blob",
      }
    );
 
    return response;
  } catch (error) {
    console.error("Error in downloadPersonnelDocument service:", error);
    throw error;
  }
}
